import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { format } from "../utils/dateHelper";

interface ILicensewarningProps {
    licenseValidUntil?: Date | null;
    isBefore: boolean;
}

const Licensewarning = (props: ILicensewarningProps) => {
    const { t } = useTranslation();

    const { licenseValidUntil, isBefore } = props;

    const [expanded, setExpanded] = useState(false);

    const toggleExpand = () => setExpanded(!expanded);

    return (
        <div className={`license-bar ${!isBefore ? "expired" : ""}`}>
            <div className="license-message">
                {/* {isBefore
                    ? `Target-Lizenz läuft am ${licenseValidUntil ? licenseValidUntil.toLocaleDateString() : "-"
                    } ab.`
                    : "Target-Lizenz ist abgelaufen."} */}
                {isBefore
                    ? t("common:license.expires" , {date:licenseValidUntil ? format(licenseValidUntil, "dd.MM.yyyy") : "-"})                    
                    : t("common:license.expired")}
            </div>

            <button className="expand-btn" onClick={toggleExpand}>
                {expanded ? "▲" : "▼"}
            </button>

            {expanded && (
                <div className={`license-details ${!isBefore ? "expired" : ""}`}>
                    <div className="license-details-block">
                        <p><strong>{t("common:license.info.title")}:</strong></p>
                        <p>{t("common:license.info.text")}</p>
                    </div>

                </div>
            )}
        </div>
    )
    
};

export default Licensewarning;
